import React from 'react'
import { TopicNavListItem, TopicNav } from './styles'

const TopicNavList = ({
  topics,
  focusedTopic,
  performScroll
}) => topics.map((topic) => (
    <TopicNavListItem key={topic} data-testid='nav-list-item-topic'>
      <TopicNav
        className={focusedTopic === topic ? 'selected' : null}
        role="button"
        tabIndex={0}
        onClick={() => {
          performScroll(topic)
        }}
      >
        {topic}
      </TopicNav>
    </TopicNavListItem>
  )
)


export default TopicNavList
